import { RetryLink as ApolloRetryLink } from '@apollo/client/link/retry';
import { SocketResetError } from './createAbsintheSocketLink';

/*
 * Subscription retries, mainly to reinitiate after socket reset
 */
const SubscriptionRetryLink = new ApolloRetryLink({
  delay: {
    initial: 10000, // Increased from 5s to 10s - gives socket time to reconnect first
    max: 60000, // Cap at 60 seconds to prevent indefinite growth
    jitter: true, // Randomizes delay to prevent thundering herd
  },
  attempts: {
    max: 3,
    retryIf: (error) => {
      return error === SocketResetError;
    },
  },
});

export default SubscriptionRetryLink;
